import { Card } from '@/components/Bicester';
import React from 'react';
import ServiceInfo from '@/views/SiteService/components/ServiceInfo';
import { fetchEditShopping, fetchShoppingInfo } from '@/services/subscribe/shopping';
import { defaultDetailInfo, orderStatus, shoppingDetailSchema } from '../Shopping/constants';
import { FieldArray } from 'formik';
import useSiteBrandList from '@/hooks/preload/useSiteBrandList';

const ShoppingInfo = () => {
  const { data: brandList, loading: brandListLoading } = useSiteBrandList();

  return (
    <ServiceInfo
      basicLoading={brandListLoading}
      defaultServiceInfo={defaultDetailInfo}
      serviceSchema={shoppingDetailSchema}
      fetchInfo={fetchShoppingInfo}
      fetchEdit={fetchEditShopping}
      getDefaultInfo={(data) => {
        return {
          handsfree_status: data?.handsfree_status,
          handsfree_items: data?.handsfree_items,
          remark: data?.remark,
          member_id: data?.member_id,
        };
      }}
      getSubmitData={(id, values) =>
        Object.assign({}, values, {
          id,
          handsfree_items: JSON.stringify(
            values?.handsfree_items?.map((item) => {
              return {
                brand_name: item.brand_name,
                num: item.num,
              };
            }) || []
          ),
        })
      }
      serviceInfo={({ formik, infoData, isEdit }) => (
        <>
          <Card.Picker
            notEditable
            label="服务状态"
            formKey="handsfree_status"
            pickerData={orderStatus}
            value={infoData?.handsfree_status}
          />
          <FieldArray name="handsfree_items">
            {({ insert, remove, push }) => (
              <>
                {formik?.values?.handsfree_items.length > 0 &&
                  formik?.values?.handsfree_items?.map((item, index) => (
                    <div className="flex" key={index}>
                      <Card.Picker
                        required
                        isEdit={isEdit}
                        className="flex-[3]"
                        label="免提品牌"
                        formKey={`handsfree_items.${index}.brand_name`}
                        pickerData={brandList}
                        value={infoData?.handsfree_items[index]?.brand_name}
                        searchable
                        labelWeight={5}
                      />
                      <div className="flex-1 flex items-center">
                        <div className="text-[#999999] ml-[20px]">包裹数</div>
                        <Card.Input
                          isEdit={isEdit}
                          className="mx-[10px]"
                          inputStyle={{ textAlign: 'center', padding: 0 }}
                          inputType="number"
                          formKey={`handsfree_items.${index}.num`}
                        />
                      </div>
                    </div>
                  ))}
              </>
            )}
          </FieldArray>
        </>
      )}
    />
  );
};

export default ShoppingInfo;
